import { Action, State } from './filter.interface';

const startDate = new Date();
startDate.setDate(startDate.getDate() - 30);

export const initialFiltersState: State = {
  flagType: 'Todos',
  startDate,
  endDate: new Date(),
  supplier: ''
};

export const reducerFilters = (state: State, action: Action) => {
  switch (action.type) {
    case 'FLAG_TYPE':
      return {
        ...state,
        flagType: action.flagType
      };
    case 'SUPPLIER':
      return {
        ...state,
        supplier: action.supplier
      };
    case 'START_DATE':
      return {
        ...state,
        startDate: action.startDate
      };
    case 'END_DATE':
      return {
        ...state,
        endDate: action.endDate
      };
    default:
      return state;
  }
};
